export const ImageReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_IMAGE':
          return action.item;
        case 'REMOVE_IMAGE':
            return state.filter((e,i) => i !== action.index);     
        default:
          return state
    }
}